export default "__VITE_ASSET__C$Zk3p7U__"